import React, { ReactElement } from 'react';
import styles from './accountLockedPage.module.scss';
import { Title } from '../../../components/title/Title';
import { FORGOT_PASSWORD_PAGE } from '../../../common/routes';
import { useHistory } from 'react-router-dom';

const AccountLockedPage = (): ReactElement => {
    const history = useHistory();
    return (
        <div className={styles.gridContainer}>
            <div className={styles.page}>
                <div className={styles.form}>
                    <div className={styles.formHeader}>
                        <div className={styles.formHeaderContent}>
                            <Title title='Your account has been locked' />
                        </div>
                    </div>
                    <p>This is because there have been too many failed attempts to enter your current password.</p>
                    <p>
                        Please follow the steps to{' '}
                        <a
                            href={'/change-password'}
                            onClick={(e: React.MouseEvent): void => {
                                e.preventDefault();
                                history.push(FORGOT_PASSWORD_PAGE);
                            }}
                        >
                            reset your password
                        </a>{' '}
                        to unlock your account.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AccountLockedPage;
